import { useQuery } from "@tanstack/react-query";
import { getUserModuleBasedPermissions } from "../services/maintainerServices";

export const useUserModulePermissions = (module, userId) => {
  return useQuery({
    queryKey: ["userModulePermissions", module, userId],
    queryFn: () => getUserModuleBasedPermissions(module, userId),
    enabled: !!module && userId && userId !== "undefined",
    keepPreviousData: true,
  });
};
